'use strict'

let _dataStore = {};

let EventBusUtil = {
    /**
     * @return EventBusUtil
     */
    init: function(initParam){
        // do some init stuff here
        _dataStore = initParam && initParam.dataStore ? initParam.dataStore : {};
        return this;
    },

    /**
     * Subscribe to Event
     * 
     * @param {String} eventName 
     * @param {String} identifier 
     * @param {function} fn 
     */
    subscribe(eventName, identifier, fn){
        if(!_dataStore[eventName]){
            _dataStore[eventName] = {};
        }
        if(_dataStore[eventName][identifier]){
            return;
        }
        _dataStore[eventName][identifier] = fn;
        return this;
    },

    /**
     * Dispatch Event
     * @param {String} eventName 
     */
    dispatch(eventName){
        var subscriptions = _dataStore[eventName];
        if(subscriptions){
            for(var id in subscriptions) {
                subscriptions[id].apply(null, Array.prototype.slice.call(arguments, 1));
            }
        }
    },

    /**
     * Unsubscribe to an Event by identifier
     * @param {String} eventName 
     * @param {String} identifier 
     */
    unsubscribe(eventName, identifier){
        if(_dataStore[eventName] && _dataStore[eventName][identifier]){
            delete _dataStore[eventName][identifier];
        }
        return this;
    },

    /**
     * Get all subscriptions by Event Name
     * @param {String} eventName 
     */
    subscriptions(eventName){
        return _dataStore[eventName] ? _dataStore[eventName] : {};
    },
};

module.exports = EventBusUtil;


// WEBPACK FOOTER //
// ./src/core/EventBus.js